<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>CRONMIND</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont" class="product_sees">
      <div class="subCon seesCon inner_box">
        <div class="mainBox">
          <!-- 기대효과 -->
          <div class="benefit-1">
            <section id="benefit">
              <h3 class="con_tit" style="margin-bottom: 30px">CRONMIND 소개</h3>
              <div class="sstxt">
                <p style="font-size: 24px">
                  전자금융감독규정 제30조 (일괄작업에 대한 통제) 등 관련 법규
                  준수를 지원하며, 주 52시간 근무 준수를 위한 IT 운영 효율화를
                  지원하여 대형 은행 등에서 도입하여 적용되고 있는 Crontab 작업
                  관리 전문 솔루션입니다.
                </p>
              </div>
              <v-img
                src="@/assets/img/product/sees/cronmindBenefit.png"
                style="width: 1000px; height: 450px; margin: 0 auto"
              />
            </section>
          </div>

          <!-- 특장점 및 기능 -->
          <div>
            <section id="features">
              <div class="sstxt">
                <p style="font-size: 24px">
                  각 서버에 설치된 Agent를 통해 Crontab 작업정보, 수행정보(계정
                  및 권한정보 포함) 및 수행결과를 수집하고 Crontab작업
                  변경내용을 반영합니다. 또한 Web UI 기반 결재 관리를 통해, 전사
                  Crontab작업의 통제 관리를 지원합니다.
                </p>
              </div>
              <v-img
                src="@/assets/img/product/sees/cronmindFeatures.png"
                style="width: 1000px; height: 480px; margin: 0 auto"
              />
            </section>
          </div>

          <!-- 레퍼런스 -->
          <div class="reference-1">
            <section id="reference">
              <div class="sstxt">
                <p style="font-size: 24px">
                  각 서버에 설치된 Agent를 통해 서버에서 수행되는 Crontab 정보
                  및 수행 결과(시작 및 종료)를 수집하여 Web UI 기반 WorkFlow
                  관리를 통해 모니터링 하며, 전사 Crontab 작업의 통제 시스템을
                  구축하였습니다.
                </p>
              </div>
              <v-img
                src="@/assets/img/product/sees/cronmindReference.png"
                style="width: 1000px; height: 560px; margin: 0 auto"
              />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
